module.exports = __webpack_public_path__ + "static/media/FlorArbol.fb83ef45.png";